module.exports = __webpack_public_path__ + "img/headphones-simple.10cf57fd.svg";